/* eslint-disable no-use-before-define */
import React from 'react'
import Grid from './grid'
import {default as useQuickIdeas, onViewAll} from './use-quick-ideas'
import { Loading, getState, getConfig, Disclosures, STATES_AND_TERRITORIES } from '../../twd'

export default () => {
    const defaultState = getConfig('account_states.0.stateOfResidence','')
    const Last = getState('overview.quick-ideas')
    const [state, setState_] = React.useState(Last.value.stateTs ? Last.value.state : defaultState)

    const {status, data, Status, setStatus} = useQuickIdeas({
        id: 'QUICK_IDEAS_TAX_ADVANTAGED_MUNIS',
        url: '/esb/retailservice/quickIdeasService/getTaxAdvantaged',
        params: {
            state,
            quickPickGroupSubTypeList: ['QUICK_IDEAS_TAX_ADVANTAGED_MUNIS']
        }
    })
    const setState = React.useCallback((s) => {
        Last.set({state:s, stateTs:Date.now()})
        setState_(s)
        setStatus(Status.LOADING)
    }, [])


    return <React.Fragment>
        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-md-12 col-xs-12">
            <h3 style={{display:'inline-block', paddingRight:'10px'}} className="medium-header">Tax Advantaged</h3>
            <Disclosures
                dataModule='overview-quick-ideas'
                dataCategory='tax-advantaged'
                dataName='overview-quick-ideas-tax-advantaged-learn-more-link'
                label='Learn more'
                html={DISCLOSURES} />
        </div></div>

        <div className="row vertical-offset-sm"><div className="col-md-12 col-xs-12">
        Short and medium-term tax-advantaged municipal bonds offered in your state of residence.
        </div></div>

        <div className="row vertical-offset-sm">
            <div className="col-md-4 col-xs-12">
                <div className="select-wrapper">
                <select
                    data-module='overview-quick-ideas'
                    data-category='tax-advantaged'
                    data-name='overview-quick-ideas-tax-advantaged-state'
                    aria-label='Select state'
                    defaultValue={state}
                    onChange={(e) => setState(e.target.value)}
                    className="form-control">
                {
                    [{label:'All', value:''}]
                    .concat(STATES_AND_TERRITORIES)
                    .map( (a,i) => {
                        return <option key={i} value={a.value}>{a.label}</option>
                    })
                }
                </select>
                </div>
            </div>
            <div className="col-md-2 col-xs-12">&nbsp;</div>
            <div className="col-md-6  col-xs-12 equally-spaced">
                <div>Additional Offerings:</div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='tax-advantaged'
                    data-name='overview-quick-ideas-tax-advantaged-less-than-2-year-link'
                    className="link-button"
                    onClick={() => onView(state, {holdMaturityMax:'2y'})}
                >&lt;2 years</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='tax-advantaged'
                    data-name='overview-quick-ideas-tax-advantaged-between-2-year-to-5-year-link'
                    className="link-button"
                    onClick={() => onView(state, {holdMaturityMin:'2y', holdMaturityMax:'5y'})}
                >2 - 5 years</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='tax-advantaged'
                    data-name='overview-quick-ideas-tax-advantaged-between-5-year-to-10-year-link'
                    className="link-button"
                    onClick={() => onView(state, {holdMaturityMin:'5y', holdMaturityMax:'10y'})}
                >&gt;5 - 10 years</button></div>
            </div>
        </div>

        <div className="row"><div className="col-md-12">
        <Loading status={status}>
            <Grid
                dataCategory='tax-advantaged'
                dataName='overview-quick-ideas-tax-advantaged'
                rows={data} />
        </Loading>
        </div></div>

    </React.Fragment>
}

const onView = (state, p) => {
    let searchParams = Object.assign({
        holdInvType: ['M'],
        offeringType: ['ask-side'],
        holdMoodyRatingMin: 'Baa3',
        holdSpRatingMin: 'BBB-',
        quantityMin: 10,
        clientPriceMin: 95,
        clientPriceMax: 120,
        holdCouponMin: 4,
        holdCouponPayFrequency: ['S'],
        holdCouponTypeCode: ['FNZR'],
        holdCallableInd: ['N'],
        holdRefundInd: ['N'],
        holdTaxable: ['N'],
        holdAltMinTax: ['N'],
        ...(state && {holdState:[state]}),
        persistToPreviousSearches: false,
        sort: [{ field:'askYield', direction:'DESC' }]
    }, p)
    onViewAll({searchParams})
}


const DISCLOSURES = `
    <p>
    This category features investment-grade (Baa3/BBB- and above) municipal bond
    results with maturities ranging from 2 to 10 years – based upon
    the physical state of residence we have on file for your account*.
    All results displayed are from dealers offering a minimum of 10 bonds,
    with an offering price between 95 and 120.
    All bonds feature a minimum 4% coupon and semi-annual interest payments.
    Each of the three rows will feature a unique maturity range.
    Row 1: (<2yr), Row 2: (2yr – 5yr), Row 3: (5yr - 10yr).
    </p>

    <p>
    Interest income on bonds issued by U.S. states, cities, and counties,
    is generally federal-tax-exempt and state-tax-exempt for residents of the state
    in which the issuer resides, however, tax-exempt status depends on several factors,
    please consult your tax advisor regarding your personal situation.
    </p>

    <p class="text-small">
    *Note: If E*TRADE has no physical state of residence on file,
    national municipal bonds will populate which adhere to the aforementioned criteria.
    </p>`


// WEBPACK FOOTER //
// ./src/overview/quick-ideas/tax-advantaged.js